export enum RequestType {
    All,
    OpeningStock,
    Inward,
    tertiary
}